export default __webpack_public_path__ + "static/media/plus.384879d5.svg";